import axios from "./AxiosService";

export function getCoverSummary(membershipNumber, clientId) {
  return axios
    .get("cover", {
      params: { membershipNumber: membershipNumber, securityId: clientId }
    })
    .then(response => {
      return response;
    })
    .catch(error => {
      return error;
    });
}
